// material-ui
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items/index';

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
    const authUser = useSelector((state) => state.auth.user);

    const navItems = menuItem[authUser.role].map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
